import { observer } from 'mobx-react';
import React from 'react';
import { Button, Grid, GridColumn, Heading, List, ListItem, Modal, ModalCloser, ModalContent, ModalFooter, Text } from '@teliaee/design-system';
import useStores from '../stores/UseStores';
import { useIsTabletHook } from '../util/hooks/useIsMobile';
import PasskeyOfferRegisterResultModal from './PasskeyOfferRegisterResultModal';

const PasskeyOfferRegister = observer((): React.JSX.Element => {
  const {
    passkeyStore: {
      offerRegisterModalVisible,
      offerRegisterModalOnComplete,
      register,
      skipPasskeyOfferRegister,
      wasPasskeyRegisterSuccessful,
      isWebAuthnInProgress,
    },
    translateStore: { translate },
  } = useStores();
  const { isTablet } = useIsTabletHook();

  const skipPasskeyRegister = async () => {
    await skipPasskeyOfferRegister();
    offerRegisterModalOnComplete();
  };

  const addPasskey = () => register();

  if (wasPasskeyRegisterSuccessful !== null) {
    return <PasskeyOfferRegisterResultModal />;
  }

  return (
    <Modal isOpen={offerRegisterModalVisible} isFullHeight={!isTablet} onClose={skipPasskeyRegister}>
      <ModalContent>
        <Grid horizontalGutter="none" verticalGutter="smedium">
          <GridColumn width={['xs-11']}>
            <Heading level={1} className="h3">
              {translate('passkey.offerRegister.heading')}
            </Heading>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <Text className="h5" element="p">
              {translate('passkey.offerRegister.subHeading')}
            </Text>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <List type="icon" horizontalSpacing="none">
              <ListItem icon="#fingerprint">{translate('passkey.offerRegister.listItem.fingerprint')}</ListItem>
              <ListItem icon="#face-id">{translate('passkey.offerRegister.listItem.faceId')}</ListItem>
              <ListItem icon="#phone-lock">{translate('passkey.offerRegister.listItem.phoneLock')}</ListItem>
            </List>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <Button link text={translate('panel.passkey.cta')} target="_blank" url={translate('panel.passkey.cta.url')} />
          </GridColumn>
        </Grid>
      </ModalContent>
      <ModalFooter>
        <Grid align={['between-xs', 'middle-xs']} gutter="small">
          <GridColumn width={['min-xs']}>
            <ModalCloser>
              <Button text={translate('passkey.offerRegister.footer.skip')} link onClick={skipPasskeyRegister} />
            </ModalCloser>
          </GridColumn>
          <GridColumn width={['min-xs']}>
            <ModalCloser>
              <Button disabled={isWebAuthnInProgress} text={translate('passkey.offerRegister.footer.addPasskey')} type="expressive" onClick={addPasskey} />
            </ModalCloser>
          </GridColumn>
        </Grid>
      </ModalFooter>
    </Modal>
  );
});

export default PasskeyOfferRegister;
